// extracted by mini-css-extract-plugin
export default {"container":"heroSection_container__ZC8gP","content":"heroSection_content__UqwT+"};